// AlphaLift Forge Theme JS
document.addEventListener('DOMContentLoaded', () => {
  console.log('AlphaLift Forge Theme Initialized');

  // Reveal animations on scroll
  const revealItems = document.querySelectorAll('.reveal-item');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-up');
        entry.target.style.opacity = '1';
      }
    });
  }, { threshold: 0.1 });

  revealItems.forEach(item => {
    item.style.opacity = '0';
    revealObserver.observe(item);
  });
});

// Global cart update helper
window.addItemToCart = function(variantId, button) {
  if (button) {
    button.disabled = true;
    const originalText = button.querySelector('span').textContent;
    button.querySelector('span').textContent = 'Adding...';
  }

  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
  .then(response => response.json())
  .then(data => {
    if (button) {
      button.querySelector('span').textContent = 'Added!';
      setTimeout(() => {
        button.querySelector('span').textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
    
    // Update cart UI
    refreshCartUI().then(() => {
      if (typeof openCartDrawer === 'function') {
        openCartDrawer();
      }
    });
  })
  .catch(error => {
    console.error('Error:', error);
    if (button) button.disabled = false;
  });
};

// Refresh Cart UI without reloading
window.refreshCartUI = function() {
  return fetch(window.location.href)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update Drawer
      const newDrawerContent = doc.getElementById('CartDrawer');
      const currentDrawer = document.getElementById('CartDrawer');
      if (newDrawerContent && currentDrawer) {
        // We only want to update the inner part to preserve the drawer's open/close state if it's already open
        // But here we usually want to refresh everything inside.
        // Let's replace everything inside the aside.
        currentDrawer.innerHTML = newDrawerContent.innerHTML;
        
        // Re-attach close listeners because we just replaced the HTML
        if (typeof closeCartDrawer === 'function') {
          const closeBtn = currentDrawer.querySelector('#CartDrawerClose');
          if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
        }
      }
      
      // Update Header Count
      const newCount = doc.getElementById('CartCount');
      const currentCount = document.getElementById('CartCount');
      if (newCount && currentCount) {
        currentCount.innerHTML = newCount.innerHTML;
        if (newCount.classList.contains('hidden')) {
          currentCount.classList.add('hidden');
        } else {
          currentCount.classList.remove('hidden');
        }
      }
      
      // Update Cart Drawer Count in title if exists
      const newDrawerCount = doc.getElementById('CartDrawerCount');
      const currentDrawerCount = document.getElementById('CartDrawerCount');
      if (newDrawerCount && currentDrawerCount) {
        currentDrawerCount.innerHTML = newDrawerCount.innerHTML;
      }
    });
};
